import * as actionTypes from "../_constants/url.constant";
const initialState = {
  redirectTo: ""
};
export function url(state = initialState, action) {
  switch (action.type) {
    case actionTypes.DISPATCH_URL: {
      return {
        ...state,
        redirectTo: action.payload
      };
    }
    default:
      return { ...state };
  }
}
